var _rect, _path, _g, _g2, _g3, _mask, _path2, _path3, _rect2, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6023 -466C-6023 -467.104 -6022.1 -468 -6021 -468H856C857.105 -468 858 -467.105 858 -466V7869C858 7870.1 857.105 7871 856 7871H-6021C-6022.1 7871 -6023 7870.1 -6023 7869V-466Z",
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    transform: "translate(-1283 -62)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: -62,
    width: 50.0001,
    height: 1440,
    transform: "rotate(90 157 -62)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: -62.5,
    width: 51.0001,
    height: 1441,
    transform: "rotate(90 157.5 -62.5)",
    stroke: "url(#paint0_linear_0_1)",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    transform: "translate(-1283 -62)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: -65,
    width: 50.0001,
    height: 1440,
    transform: "rotate(90 157 -65)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: -65.5,
    width: 51.0001,
    height: 1441,
    transform: "rotate(90 157.5 -65.5)",
    stroke: "url(#paint1_linear_0_1)",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-846 -13H157V27H-846V-13Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-846 -13H157V27H-846V-13Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 -13V27H158V-13H156Z",
    fill: "#D4D4D4",
    mask: "url(#path-7-inside-1_0_1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 23,
    height: 23,
    rx: 3,
    fill: "#535353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C4.77582 0 3.12306 0.684752 1.9035 1.9035C0.684752 3.12304 0 4.77588 0 6.5C0 8.22412 0.684752 9.87694 1.9035 11.0965C3.12304 12.3152 4.77588 13 6.5 13C8.22412 13 9.87694 12.3152 11.0965 11.0965C12.3152 9.87696 13 8.22412 13 6.5C13 4.77588 12.3152 3.12306 11.0965 1.9035C9.87696 0.684752 8.22412 0 6.5 0ZM6.5 11.375C5.20746 11.375 3.96724 10.8616 3.05318 9.94676C2.13833 9.0327 1.62497 7.79262 1.62497 6.49994C1.62497 5.20726 2.13833 3.96718 3.05318 3.05312C3.96724 2.13827 5.20732 1.62491 6.5 1.62491C7.79268 1.62491 9.03276 2.13827 9.94682 3.05312C10.8617 3.96718 11.375 5.20726 11.375 6.49994C11.375 7.79262 10.8617 9.0327 9.94682 9.94676C9.03276 10.8616 7.79268 11.375 6.5 11.375Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31249 3.85938H5.68749V7.10936H4.0625L6.49999 9.54686L8.93748 7.10936H7.31249V3.85938Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-6021 -467H856V-469H-6021V-467ZM857 -466V7869H859V-466H857ZM856 7870H-6021V7872H856V7870ZM-6022 7869V-466H-6024V7869H-6022ZM-6021 7870C-6021.55 7870 -6022 7869.55 -6022 7869H-6024C-6024 7870.66 -6022.66 7872 -6021 7872V7870ZM857 7869C857 7869.55 856.552 7870 856 7870V7872C857.657 7872 859 7870.66 859 7869H857ZM856 -467C856.552 -467 857 -466.552 857 -466H859C859 -467.657 857.657 -469 856 -469V-467ZM-6021 -469C-6022.66 -469 -6024 -467.657 -6024 -466H-6022C-6022 -466.552 -6021.55 -467 -6021 -467V-469Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_0_1",
    x: -1324,
    y: -103,
    width: 1522,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -1307,
    y: -85,
    width: 1488,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 207,
    y1: 715,
    x2: 157,
    y2: 577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 207,
    y1: 712,
    x2: 157,
    y2: 574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    fill: "white",
    transform: "translate(-1283 -62)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    fill: "white",
    transform: "translate(-1283 -62)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.5dc31d6b35bb365d7ca5c31807ffbb9f.svg";
export { ForwardRef as ReactComponent };